import React, { Fragment, memo } from 'react'

import PartListing from '../common/PartListing'
import ToggleView from '../common/ToggleView'

import {
  GridContainer,
  SectionHeading,
  Heading,
  End,
} from './GridView.css'

const GridView = ({
  categoryPart,
  isListView,
  toggleListView,
  selVName,
  Link,
}) => {
  if (isListView) return null

  return categoryPart.map((item, index) => (
    <Fragment key={item.text}>
      <GridContainer
        justify="between"
        align="start"
      >
        <SectionHeading
          id={`SectionHeading${index}`}
          align="start"
        >
          <Heading
            title={item.text}
          />
        </SectionHeading>

        {index === 0 && (
        <End>
          <ToggleView
            listView={isListView}
            toggleListView={toggleListView}
          />
        </End>
        )}
      </GridContainer>

      <PartListing
        parts={item.categories}
        Link={Link}
        gridId={index + 1}
        selectedVehicle={selVName.trim()}
        isVLP
      />
    </Fragment>
  ))
}

export default memo(GridView)
